import React from 'react';

type LogoProps = {
  className?: string;
};

export default function Logo({ className }: LogoProps) {
  return <img data-component-id="src/components/Logo.tsx:8:9" data-component-path="src/components/Logo.tsx" data-component-line="8" data-component-end-line="8" data-component-file="Logo.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%2Fassets%2Fimages%2Ficon.svg%22%2C%22alt%22%3A%22Ghost%20Ai%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" src="/assets/images/icon.svg" alt="Ghost Ai" className={className} />;
}
